module.exports = __webpack_public_path__ + "img/introduction.dc68c042.jpg";